import React from 'react';
import { useRouter } from 'next/router';
import {
  ChangePasswordModal,
  WhatsAppButton,
  FloatingCartButton,
} from '../shared';
import { useCompanyBranding, useUser } from '../../hooks';
import { Color } from '../../models';
import { useShopCart } from '../../hooks/useShopCart';
import Footer from '../navigation/Footer';
import Navbar from '../navigation/Navbar';
import DropdownMenu from '../navigation/DropdownMenu';

interface LayoutProps {
  children: React.ReactNode;
  lowMargin?: boolean;
}

function Layout({ children, lowMargin }: LayoutProps) {
  const router = useRouter();
  const [user] = useUser();
  const [companyBranding] = useCompanyBranding();
  const [shopCart] = useShopCart();

  // if its the first login, show the change password modal
  const [changePasswordModalIsOpen, setChangePasswordModalIsOpen] =
    React.useState(!user?.firstLogin);

  const [isOpen, setIsOpen] = React.useState(false);
  const tooggleOpen = () => {
    setIsOpen(!isOpen);
  };

  // We expect companibranding.colors to be different from null so that we can set the styles.
  React.useEffect(() => {
    if (!companyBranding?.colors) return;
    // Lets iterate over the colors and set the styles
    companyBranding?.colors?.forEach((color: Color) => {
      const shadeKeys = Object.keys(color.shades);
      shadeKeys.forEach((shade) => {
        document.documentElement.style.setProperty(
          `${color.name}-${shade}`,
          color.shades[shade]
        );
      });
    });
  }, [companyBranding?.colors]);

  const renderFloatingCartButton = router.pathname !== '/shopping';

  return (
    <main className="w-full min-h-screen overflow-hidden relative flex flex-col bg-white">
      <Navbar openClose={tooggleOpen} />
      {isOpen && <DropdownMenu closeOpen={tooggleOpen} />}
      <div
        className={`w-full flex flex-col overflow-x-hidden relative ${
          router.pathname !== 'router' ? 'min-h-screen' : ''
        } ${lowMargin ? '' : 'mt-10'}`}
      >
        {children}
      </div>
      <div className="w-full overflow-hidden">
        <Footer />
      </div>
      {user ? (
        <ChangePasswordModal
          isOpen={changePasswordModalIsOpen}
          setOpen={setChangePasswordModalIsOpen}
          firstLogin
        />
      ) : null}
      {shopCart && renderFloatingCartButton ? (
        <FloatingCartButton shopCart={shopCart} />
      ) : null}
      <WhatsAppButton />
    </main>
  );
}

export default Layout;
